import { render, staticRenderFns } from "./ProductsBySellerModal.vue?vue&type=template&id=3b546664&scoped=true&"
import script from "./ProductsBySellerModal.vue?vue&type=script&lang=ts&"
export * from "./ProductsBySellerModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsBySellerModal.vue?vue&type=style&index=0&id=3b546664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b546664",
  null
  
)

export default component.exports